import { Skeleton, Stack, Text } from 'components'
import { ArcPageShell } from 'components/ArcPageShell'
import { useArcTranslation } from 'hooks'
import { ResourceCenterTabs } from './components/ResourceCenterTabs'
import { useResourceHubs } from './hooks/useResourceHubs'

const LOADING_ROWS = 4

// Index view: page heading + search/tabs. Article list scrolls with the main
// content area (the Layout keeps the sidebar fixed).
export const ResourceCenterContent = () => {
  const { t } = useArcTranslation()
  const { hubs, language, isLoading, isError } = useResourceHubs()

  return (
    <ArcPageShell title={t('resource_center.title')} subtitle={t('resource_center.description')}>
      {isLoading ? (
        <Stack spacing='md'>
          <Skeleton height={48} radius='xl' />
          {Array.from({ length: LOADING_ROWS }, (_, index) => (
            <Skeleton key={index} height={72} radius='md' />
          ))}
        </Stack>
      ) : isError ? (
        <Text color='red' size='sm'>
          {t('resource_center.load_error')}
        </Text>
      ) : (
        // Keyed by language so search, tag selection and active tab reset
        // when the in-app language changes (hub/tag documents are
        // per-language, so their slugs and _ids do not carry over).
        <ResourceCenterTabs key={language} hubs={hubs} />
      )}
    </ArcPageShell>
  )
}
